import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import './style.scss';

class Menu extends Component {

    constructor(props, context) {
		super(props, context);

        this.state = {}
    }

    openModal = () => {
        alert('open modal');
    }

    render = () => {
        return (
            <div className="header">
                <div className="section is-paddingless is-marginless has-text-centered">
                    <div className="columns center">
                        <div className="column is-12 center">
                            <img className="logo" src="weland_utemiljo_logo.svg" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    console.log(state);
      return {
      };
  };
  const mapDispatchToProps = (dispatch) => {
      return {
          // getData: bindActionCreators(UserActionCreators.fetchUser, dispatch),
          // logout: bindActionCreators(AuthenticationCreators.logout, dispatch)
      };
  };


export default connect(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./src/Components/Menu/index.js